import { render, staticRenderFns } from "./question-table.vue?vue&type=template&id=60b0563e&"
import script from "./question-table.vue?vue&type=script&lang=ts&"
export * from "./question-table.vue?vue&type=script&lang=ts&"
import style0 from "./question-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports